import { Box, BoxProps, Typography } from '@mui/material';
import React, { ReactNode } from 'react';
import { makeStyles } from 'tss-react/mui';

import EmptyIcon from '~assets/images/empty/empty.svg?react';

interface IEmptyContentProps extends Omit<BoxProps, 'title'> {
  IconComponent?: ReactNode;
  title?: ReactNode;
  desc?: ReactNode;
}

export const EmptyContent: React.FC<IEmptyContentProps> = (props) => {
  const { IconComponent, title, desc, children, className, ...rest } = props;

  const { classes, cx } = useStyles();

  return (
    <Box {...rest} className={cx(classes.emptyContainer, className)}>
      <Box mb={1}>{IconComponent || <EmptyIcon />}</Box>
      {title && (
        <Typography variant="body1" align="center" color="text.disabled">
          {title}
        </Typography>
      )}
      {desc && (
        <Typography align="center" color="text.disabled">
          {desc}
        </Typography>
      )}

      {children}
    </Box>
  );
};

const useStyles = makeStyles()(() => ({
  emptyContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    height: '100%',
  },
}));
